import styled from 'styled-components';

import sytled from 'styled-components';
export const Img = styled.img`
  margin-right: 5px;
  width: ${(props: any) =>
    props?.fontScale !== undefined
      ? `${20 + props?.fontScale * 2.5}px`
      : '20px'} !important;
`;

export const UserFormTitleStyle = {
  fontSize: '25px',
  fontWeight: 'bold',
};
